import l from "../legend-group/legend-group.vue.js";
import { resolveComponent as d, openBlock as m, createElementBlock as g, createElementVNode as c, normalizeStyle as p, createVNode as u } from "vue";
/* empty css               */
import h from "../../_virtual/_plugin-vue_export-helper.js";
const a = [
  { name: "black", hex: "#00112c" },
  { name: "green", hex: "#0abf53" },
  { name: "yellow", hex: "#ffc200" },
  { name: "blue", hex: "#0070f5" },
  { name: "grey-500", hex: "#d1d5da" },
  { name: "grey-1900", hex: "#5c687c" }
], _ = {
  name: "DsStatsBar",
  components: { DsLegendGroup: l },
  props: {
    items: {
      type: Array,
      required: !0,
      validator: (e) => {
        const t = e.reduce((r, n) => r + n.percentage, 0);
        return e.length <= a.length && t === 100;
      }
    }
  },
  data: () => ({
    colorsData: a
  }),
  computed: {
    /**
     * This function iterates the prop items, generates the sub strings for each necessary color and percentages and joins them.
     * It returns the string of the gradient with multi-position color stops needed for the background style
     *
     * @returns {String}
     * @example 'linear-gradient(to right, #00112c 0% 50%, #0abf53 50% 75%, #ffc200 75% 100%)'
     */
    backgroundStyleString() {
      let e = 0;
      return `linear-gradient(to right, ${this.items.map((r, n) => {
        const o = `${a[n].hex} ${e}% ${e + r.percentage}%`;
        return e += r.percentage, o;
      }).join(", ")})`;
    },
    legendItems() {
      return this.items.slice(0, this.colorsData.length).map((e, t) => ({ ...e, color: this.colorsData[t].name }));
    }
  }
}, f = { class: "stats-bar" }, b = { class: "ds-margin-top-12 ds-md-margin-top-24" };
function x(e, t, r, n, o, s) {
  const i = d("DsLegendGroup");
  return m(), g("div", f, [
    c("div", {
      class: "stats-bar__bar",
      style: p({ background: s.backgroundStyleString }),
      "aria-hidden": "true"
    }, null, 4),
    c("div", b, [
      u(i, { items: s.legendItems }, null, 8, ["items"])
    ])
  ]);
}
const G = /* @__PURE__ */ h(_, [["render", x]]);
export {
  G as default
};
